<template>
  <div class="container">
    <div class="cloud row mx-auto align-items-center" style="height:85vh">
      <div class="col-4">
        <img src="../../assets/image/pic_plant.png" alt="">
      </div>
      <div class="col-4">
        <div class="type-title">
          <h3>{{$t('choose_the_course')}}</h3>
          <p class="my-4" style="font-size:20px">{{$t('click_icon_t')}} <font-awesome-icon class="form_icon" :icon="['fas', 'bars']" /> {{$t('click_icon_b')}}</p>
        </div>
      </div>
      <div class="col-4">
        <img src="../../assets/image/pic_plant.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'CloudHome',

  data () {
    return {
    }
  },
  mounted () {
    if (this.$store.state.auth) {
      this.$router.push({name: 'login'})
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/style/color.scss";
  .type-title {
    text-align: left;
    h3 {
      font-weight: bold;
    }
  }
  .unit-box {
    cursor: pointer;
    position: relative;
    h5 {
      width: 100%;
      position: absolute;
      bottom: 30px;
      color: black;
    }
    &:hover {
      -webkit-filter: drop-shadow(0px 0px 8px #a1a1a1);
      filter: drop-shadow(0px 0px 8px #a1a1a1)
    }
  }
  @media screen and (min-width: 768px) {
    .cloud {
      width:80%;
    }
  }
</style>


// WEBPACK FOOTER //
// CloudHome.vue?d52a888a